const API_URL = process.env.REACT_APP_API_URL;

// Site language -> CMS language id. The CMS makes ids from the first two
// letters of the language name, so create them as English, Romanian, Russian.
const POST_LANGUAGE = { uk: "en", ro: "ro", ru: "ru" };

async function request(path) {
  const response = await fetch(`${API_URL}${path}`);

  if (!response.ok) {
    const error = new Error(response.statusText);
    error.status = response.status;
    throw error;
  }

  return response.json();
}

export const POSTS_PER_PAGE = 9;

// Resolves to { items, total, page, page_size }.
export function getPosts(appLang, page = 1) {
  const languageId = POST_LANGUAGE[appLang] || appLang;
  const query = new URLSearchParams({
    language_id: languageId,
    page,
    page_size: POSTS_PER_PAGE,
  });
  return request(`/posts?${query}`);
}

export function getPost(id) {
  return request(`/posts/${encodeURIComponent(id)}`);
}

const DATE_LOCALE = { uk: "en-GB", ro: "ro-RO", ru: "ru-RU" };

// A post's display_date ("YYYY-MM-DD"), the only date shown on the site.
export function formatPostDate(day, appLang) {
  // Read and shown as UTC so the day doesn't shift in other time zones.
  return new Date(`${day}T00:00:00Z`).toLocaleDateString(
    DATE_LOCALE[appLang] || "en-GB",
    { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }
  );
}
